export interface IWsProducto {
    IdProducto?: number;
    Codigo?: string;
    IdLinea?: string;
    Linea?: string;
    IdGrupo?: string;
    Grupo?: string;
    IdTipo?: string;
    Tipo?: string;
    IdFamilia?: string;
    Familia?: string;
    Categoria?: string;
    Nombre?: string;
    Resumen?: string;
    IdUnidadMedida?: string;
    IdMoneda?: string;
    Moneda?: string;
    PrecioNormal?: number;
    Precio?: number;
    imgRuta?: string;
    Especificaciones?: any;
    FlagActivo?: boolean;
    FlagConsultar?: boolean;
}

export class WsProducto {
    IdProducto?: number;
    Codigo?: string;
    IdLinea?: string;
    Linea?: string;
    IdGrupo?: string;
    Grupo?: string;
    IdTipo?: string;
    Tipo?: string;
    IdFamilia?: string;
    Familia?: string;
    Categoria?: string;
    Nombre?: string;
    Resumen?: string;
    IdUnidadMedida?: string;
    IdMoneda?: string;
    Moneda?: string;
    PrecioNormal?: number;
    Precio?: number;
    imgRuta?: string;
    Especificaciones?: any;
    FlagConsultar?: boolean;
    FlagActivo?: boolean;

    constructor(data?: IWsProducto) {
        if (!data) {
            data = {} as IWsProducto;
        }

        this.IdProducto = data.IdProducto;
        this.Codigo = data.Codigo;
        this.IdLinea = data.IdLinea;
        this.Linea = data.Linea;
        this.IdGrupo = data.IdGrupo;
        this.Grupo = data.Grupo;
        this.IdTipo = data.IdTipo;
        this.Tipo = data.Tipo;
        this.IdFamilia = data.IdFamilia;
        this.Familia = data.Familia;
        this.Categoria = data.Categoria;
        this.Nombre = data.Nombre;
        this.Resumen = data.Resumen;
        this.IdUnidadMedida = data.IdUnidadMedida;
        this.IdMoneda = data.IdMoneda;
        this.Moneda = data.Moneda;
        this.PrecioNormal = data.PrecioNormal;
        this.Precio = data.Precio;
        this.imgRuta = data.imgRuta;
        this.FlagActivo = data.FlagActivo;
        this.FlagConsultar = data.FlagConsultar;
        // Este campo en la bd es un string de tipo json
        this.Especificaciones = typeof data.Especificaciones === 'string' ?
            JSON.parse(data.Especificaciones) : (data.Especificaciones || {});
    }
}

export interface IProductoClasificacion {
    Id: string;
    Detalle: string;
}

// Ficha del artículo completa
export interface IWsProductoResult {
    Articulo: {
        IdArticulo: number,
        CodCipsa: string,
        Nombre: string,
        UM: string,
        Moneda: string,
        PrecioWeb: number,
        DescripcionComercial: string,
        IdLinea: string,
        Linea: string,
        IdGrupo: string,
        Grupo: string,
        IdTipo: string,
        Tipo: string,
        IdFamilia: string,
        Familia: string,
        Resumen: string,
        PrecioWebCondiciones: string,
    };

    UnidadesMedida: [];
    Caracteristicas: [];
    Especificaciones: [];
    Aplicaciones: [];
    Complementos: [];
    Alternativos: [];
    Kit: [];
    Galeria: [];
    Archivos: [];
    Comentarios: [];
    Stock: any;
}

export class WsProductoResult {
    IdArticulo: number;
    CodCipsa: string;
    Nombre: string;
    UM: string;
    Moneda: string;
    PrecioWeb: number;
    DescripcionComercial: string;
    IdLinea: string;
    Linea: string;
    IdGrupo: string;
    Grupo: string;
    IdTipo: string;
    Tipo: string;
    IdFamilia: string;
    Familia: string;
    Resumen: string;
    PrecioWebCondiciones: string;

    UnidadesMedida = [];
    Caracteristicas = [];
    Especificaciones = [];
    Aplicaciones = [];
    Complementos = [];
    Alternativos = [];
    Kit = [];
    Galeria = [];
    Archivos = [];
    Comentarios = [];
    Stock: any;

    constructor(data?: IWsProductoResult) {
        if (data) {
            if (data.Articulo) {
                this.IdArticulo = data.Articulo.IdArticulo;
                this.CodCipsa = data.Articulo.CodCipsa;
                this.Nombre = data.Articulo.Nombre;
                this.UM = data.Articulo.UM;
                this.Moneda = data.Articulo.Moneda;
                this.PrecioWeb = data.Articulo.PrecioWeb || 0;
                this.DescripcionComercial = data.Articulo.DescripcionComercial;
                this.IdLinea = data.Articulo.IdLinea;
                this.Linea = data.Articulo.Linea;
                this.IdGrupo = data.Articulo.IdGrupo;
                this.Grupo = data.Articulo.Grupo;
                this.IdTipo = data.Articulo.IdTipo;
                this.Tipo = data.Articulo.Tipo;
                this.IdFamilia = data.Articulo.IdFamilia;
                this.Familia = data.Articulo.Familia;
                this.Resumen = data.Articulo.Resumen;
                this.PrecioWebCondiciones = data.Articulo.PrecioWebCondiciones;
            }

            this.UnidadesMedida = (data.UnidadesMedida || []).filter((x: any) => x.FlagVentaWeb);
            this.Caracteristicas = data.Caracteristicas || [];

            data.Especificaciones = data.Especificaciones || [];
            const nodos = data.Especificaciones.filter((x: any) => !x.IdEspecificacionPadre)
                .map((item: any) => {
                    item.ListaDetalle = data.Especificaciones.filter((x: any) => x.IdEspecificacionPadre === item.IdEspecificacion);
                    return item;
                });
            this.Especificaciones = nodos;
            this.Aplicaciones = data.Aplicaciones || [];
            this.Complementos = data.Complementos || [];
            this.Alternativos = data.Alternativos || [];
            this.Kit = data.Kit || [];
            this.Galeria = data.Galeria || [];
            this.Archivos = data.Archivos || [];
            this.Comentarios = data.Comentarios || [];

            const stock = {
                STOCK_DISPONIBLE: data.Stock.map(x => x.STOCK_DISPONIBLE).reduce(((a, b) => a + b), 0),
                UNIDAD_MEDIDA: (data.Stock[0] || {}).UNIDAD_MEDIDA
            };

            if (stock.STOCK_DISPONIBLE) {
                this.Stock = stock;
            }
        }
    }
}
